<template>
    <a :href="mainButton.url"
       class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-100 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out">
        {{ mainButton.text }}

        <a v-for="subButton in subButtons" :href="subButton.url"
           class="block px-4 py-2 text-sm leading-5 text-gray-200 focus:outline-none focus:bg-gray-100 focus:text-brand">
            {{ subButton.text }}
        </a>
    </a>
</template>

<script>
export default {
    name: "TopNavButtonMobile",

    props: {
        mainButton: {
            required: true,
            type: Object,
            Description: "The main button text and url"
        },
        subButtons: {
            required: true,
            type: Array,
            Description: "An Array of sub buttons which will each have a text and url",
        },
    },
};
</script>